import React, { useEffect, useState } from "react";
import DetailModal, { DetailModalProps } from "./detail-modal";
import { VelavuAPI, VelavuAsset, VelavuDevice } from "velavu-js-api";
import DetailModalLoading from "./detail-modal-loading";

export interface DetailModalLoadProxyProps extends DetailModalProps {
	assetID?: string;
	deviceID?: string;
}

/// A component that wraps a DetailModal with a loading state, asynchronously
/// fetching the given asset or device.
export default function DetailModalLoadProxy(props: DetailModalLoadProxyProps) {
	const [isLoading, setIsLoading] = useState(false);
	const [asset, setAsset] = useState<VelavuAsset | undefined>(props.asset);
	const [device, setDevice] = useState<VelavuDevice | undefined>(
		props.device,
	);

	const hasProvidedAsset = props.asset !== undefined;
	const hasProvidedDevice = props.device !== undefined;
	useEffect(() => {
		//Load the device
		let promise: Promise<unknown> | null = null;
		if (props.deviceID !== undefined && !hasProvidedDevice) {
			promise = VelavuAPI.devices
				.getSpecificDevice(props.deviceID)
				.then((device) => {
					setDevice(device);
					setAsset(device.asset);
				});
		}
		//Load the asset
		else if (props.assetID !== undefined && !hasProvidedAsset) {
			promise = VelavuAPI.assets
				.getSpecificAsset(props.assetID)
				.then((asset) => {
					setAsset(asset);
				});
		}

		if (promise !== null) {
			setIsLoading(true);
			promise.then(() => {
				setIsLoading(false);
			});
		}
	}, [props.deviceID, hasProvidedDevice, props.assetID, hasProvidedAsset]);

	if (isLoading) {
		return <DetailModalLoading />;
	} else {
		return <DetailModal {...props} asset={asset} device={device} />;
	}
}
